import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import NotificationAlert from './NotificationAlert';
import InconsistencyWarning from './InconsistencyWarning';
import './Navbar.css';

const Navbar = ({ user }) => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleLogout = () => {
        fetch('/api/auth/logout', {
            method: 'GET',
            credentials: 'include',
        }).then(() => {
            localStorage.removeItem('token');
            navigate('/login');
        });
    };

    if (!user) return null;

    const allowedTabs = user.allowed_tabs ? JSON.parse(user.allowed_tabs) : null;
    const hasAccess = (tab) => {
        if (user.isAdmin) return true;
        if (!allowedTabs) return true; // Se não configurado, permite tudo (ou mude para false se preferir restrito por padrão)
        return allowedTabs.includes(tab);
    };

    return (
        <nav className="navbar-container">
            <InconsistencyWarning />
            <div className="navbar">
                <NotificationAlert user={user} />
                <div className="navbar-brand">
                    <Link to="/home">
                        <img src="/logo-ra.png" alt="RA Logo" className="navbar-logo" />
                    </Link>
                </div>

                <ul className="navbar-links">
                    <li><Link to="/home">Home</Link></li>
                    {hasAccess('clientes') && <li><Link to="/clientes">Clientes</Link></li>}
                    {hasAccess('produtos') && <li><Link to="/produtos">Produtos</Link></li>}
                    {hasAccess('funcionarios') && <li><Link to="/funcionarios">Funcionários</Link></li>}
                    {hasAccess('financeiro') && <li><Link to="/financeiro">Financeiro</Link></li>}
                    {hasAccess('fornecedores') && <li><Link to="/fornecedores">Fornecedores</Link></li>}
                    {hasAccess('calendario') && <li><Link to="/calendario">Calendário</Link></li>}
                    {hasAccess('cotacoes') && <li><Link to="/cotacoes">Cotações</Link></li>}
                </ul>

                <div className="navbar-user">
                    <div className="user-info" onClick={() => setDropdownOpen(!dropdownOpen)}>
                        <img
                            src={user.photo ? (user.photo.startsWith('data:') ? user.photo : `/uploads/${user.photo}`) : '/default-avatar.png'}
                            alt="User"
                            className="user-photo"
                            crossOrigin="use-credentials"
                        />
                        <span className="username">{user.username}</span>
                        <span className="dropdown-arrow">▼</span>
                    </div>

                    {dropdownOpen && (
                        <div className="dropdown-menu">
                            <button onClick={() => navigate('/settings')}>Configurações</button>
                            <button onClick={handleLogout}>Sair</button>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
